export type KnownLocale = 'de';
export const KNOWN_LOCALES: KnownLocale[] = ['de'];

export interface I18nConfig {
  readonly locale: KnownLocale;
}

export const defaultI18nConfig: I18nConfig = {
  locale: 'de',
};

export interface I18nConfigCallbacks {
  setLocale: (locale: KnownLocale) => void;
}

export const noopI18nConfigCallbacks: I18nConfigCallbacks = {
  setLocale: () => {},
};
